import XYZ from 'ol/source/XYZ';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorTileLayer from 'ol/layer/VectorTile';
import TileJSON from 'ol/source/TileJSON';
import VectorTileSource from 'ol/source/VectorTile';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { stylefunction } from 'ol-mapbox-style';
import MVT from 'ol/format/MVT';
function getFont(font) {
    return 'sans-serif';
}

export default async function vectorLayers(projection, tileGrid, resolutions, styleJson, mins, maxs, donTdeclutter) {
     const sources = {
    };

    for (const [key, value] of Object.entries(styleJson.sources)) {
        if (sources[key]) {
            continue;
        }
        switch (value.type) {
            case 'geojson':
                sources[key] = new VectorSource({
                    projection: projection,
                    tileGrid: tileGrid,
                    format: new GeoJSON({
                        dataProjection: projection
                    }),

                });
                sources[key].set('mapbox-source',key);
                break;
            case 'vector':
                if (value.url) {
                    let tileJSON = await fetch(value.url).then(r=>r.json());
                    const tileJSONSource = new TileJSON({tileJSON: tileJSON});
                    const tileJSONDoc = tileJSONSource.getTileJSON();
                    const sourceOptions = {
                      attributions: tileJSONSource.getAttributions(),
                      format: new MVT(),
                      tileGrid: tileGrid,
                      projection: projection,
                      minZoom: mins[key] || 1,
                      maxZoom: maxs[key] || 15,
                  };
                    if (Array.isArray(tileJSONDoc.tiles)) {
                      sourceOptions.urls = tileJSONDoc.tiles;
                    } else {
                      sourceOptions.url = tileJSONDoc.tiles;
                    }
                    sources[key] = new VectorTileSource(sourceOptions);
                } else if(value.tiles) {
                    sources[key] = new VectorTileSource({
                        projection: projection,
                        tileGrid: tileGrid,
                        format: new MVT(),
                        minZoom: mins[key] || 1,
                        maxZoom: maxs[key] || 15,
                        url: value.tiles[0]
                    });
                }
                break;
            case 'raster':
                sources[key] = new XYZ({
                    projection: projection,
                    tileGrid: tileGrid,
                    requestEncoding: 'REST',
                    urls: value.tiles
                });
                sources[key].set('mapbox-source',key);
                break;
        }
    }

    const
        layers = [],
        buckets = [];
    let currentSource;
    let styleSources = styleJson.sources;
    styleJson.layers.forEach(layer => {
        if (!layer.source) {
            return;
        }
        if (!styleSources[layer.source]) {
            return;
        }


        if (currentSource !== layer.source) {
            currentSource = layer.source;
            buckets.push({
                source: layer.source,
                type: styleSources[layer.source].type,
                layers: []
            });
        }
        buckets[buckets.length - 1].layers.push(layer.id);
    });

    buckets.forEach(bucket => {
        const source = sources[bucket.source];
        if (!source) {
            return;
        }
        switch (bucket.type) {
            case 'geojson': {
                const layer = new VectorLayer({
                    declutter: !donTdeclutter,
                    source: source,
                    tileGrid: tileGrid,
                    projection: projection,
                    opacity: 1,
                    minZoom: mins[bucket.source] || 1,
                    maxZoom: maxs[bucket.source] || 15
                });
                stylefunction(layer, styleJson, bucket.layers, resolutions, null, null, getFont);
                layers.push(layer);
                break;
            }
            case 'vector': {
                const layer = new VectorTileLayer({
                    declutter: !donTdeclutter,
                    source: source,
                    tileGrid: tileGrid,
                    projection: projection,
                    opacity: 1,
                    minZoom: mins[bucket.source] || 1,
                    maxZoom: maxs[bucket.source] || 15
                });
                stylefunction(layer, styleJson, bucket.layers, resolutions, null, null, getFont);
                layers.push(layer);
                break;
            }
            case 'raster': {
                const layer = new TileLayer({
                    source: sources[bucket.source]
                });
                layers.push(layer);
                break;
            }

        }


    });

    return layers;
    
}

